import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { Message } from 'primereact/message';

interface GenerateInvoiceDialogProps {
  visible: boolean;
  onHide: () => void;
  onGenerate: (year: number) => void;
  eligibleCount?: number;
  loading: boolean;
}

export const GenerateInvoiceDialog: React.FC<GenerateInvoiceDialogProps> = ({
  visible,
  onHide,
  onGenerate,
  eligibleCount,
  loading,
}) => {
  const [year, setYear] = useState<number>(new Date().getFullYear());

  const handleGenerate = () => {
    onGenerate(year);
  };

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header="Generate Draft Invoices"
      style={{ width: 'min(95vw, 450px)' }}
      modal
      footer={
        <div>
          <Button label="Cancel" icon="pi pi-times" onClick={onHide} className="p-button-text" />
          <Button
            label="Generate"
            icon="pi pi-file-pdf"
            onClick={handleGenerate}
            loading={loading}
            autoFocus
          />
        </div>
      }
    >
      <div data-component="generate-invoice-dialog" className="flex flex-column gap-3">
        <div className="flex flex-column gap-2">
          <label htmlFor="year">Invoice Year</label>
          <InputNumber
            id="year"
            value={year}
            onValueChange={(e) => setYear(e.value || new Date().getFullYear())}
            min={2000}
            max={2100}
            useGrouping={false}
            disabled={loading}
          />
        </div>

        {eligibleCount !== undefined && (
          <Message
            severity="info"
            text={`${eligibleCount} eligible members found (ACTIVE, earns income, fee > 0)`}
          />
        )}

        <p className="text-sm text-500 mt-2">
          This will generate draft invoices for all eligible members. You can review and approve them before sending.
        </p>
      </div>
    </Dialog>
  );
};
